import { render } from "./NewsFullPreview.vue?vue&type=template&id=4beddfdb&scoped=true"
import script from "./NewsFullPreview.vue?vue&type=script&lang=js"
export * from "./NewsFullPreview.vue?vue&type=script&lang=js"

import "./NewsFullPreview.vue?vue&type=style&index=0&id=4beddfdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4beddfdb"]])

export default __exports__